<template>
    <iframe 
        ref="iframe"
        class="frame-item"
        :src="computedSrc" 
        frameborder="0"
        @load="_onLoadHandler"
    ></iframe>
</template>

<script>
export default {
    props: {
        type: {
            // href/hash
            type: String,
            default: 'href',
        },
        src: {
            type: String,
            default: '',
        },
    },
    computed: {
        orgSrc() {
            var switchObj = {
                href() {
                    return this.src;
                },
                hash() {
                    var href = window.location.href,
                        hash = window.location.hash,
                        hrefNoHash = href.replace(hash, ''),
                        pathname = window.location.pathname,
                        search = window.location.search,
                        sarchNoTs = search.replace(/[&]*ts=[0-9]{13}/g, '').replace('?&', '?');

                    return `${pathname}${sarchNoTs}#${this.src}`;
                },
            }

            var orgSrc = switchObj[this.type].bind(this);

            if (orgSrc) {
                return orgSrc();
            }

            return '';
        },
        computedSrc() {
            return this._injectTimestemp(this.orgSrc);
        },
    },
    methods: {
        _injectTimestemp(str) {
            var timestemp = new Date().getTime(),
                tsSearch = `ts=${timestemp}`;

            if (/\?/.test(str)) {
                //有search值

                return str.replace('?', `?${tsSearch}&`);
            }

            if (/#/.test(str)) {
                // 没有search，有hash

                return str.replace('#', `?${tsSearch}#`);
            }

            return str;
        },
        _onLoadHandler() {
            
        },
        // 刷新iframe
        reload() {
            try {
                this.$refs.iframe.contentWindow.location.reload();
            } catch(e) {
                // e
            }
        },
        // 返回初始src对应的地址
        backSrc() {
            try {
                this.$refs.iframe.contentWindow.location.assign(this.computedSrc);
            } catch(e) {
                // e
            }
        },
        // 获取当前iframe的地址
        getLocation() {
            return this.$refs.iframe.contentWindow.location;
        },
        // 解析地址为location
        _srcToLocation(src) {
            var ela = document.createElement('a');

            ela.href = src;

            return ela;
        },
        isInSrcPage() {
            var iframeLocation = this.getLocation(),
                srcLocation = this._srcToLocation(this.src);

            return (
                iframeLocation.pathname === srcLocation.pathname
                && iframeLocation.hash === srcLocation.hash
                && iframeLocation.search.replace('?', '').replace(/ts=[0-9]{13}/, '').replace('&', '') === srcLocation.search.replace('?', '').replace('&', '')
            )
        },
    },
}
</script>

<style lang="scss" scoped>
    .frame-item{
        width: 100%;
        height: 100%;
    }
</style>